import './assets/tailwind.css'
import '@/assets/styles.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { version } from '../package.json'

import Aura from '@primeuix/themes/aura'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import { definePreset } from '@primeuix/themes'
import { LOCALE_IT } from './locale/it'

import JsonExcel from 'vue-json-excel3'

import * as Sentry from '@sentry/vue'

const MyDefaultPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{orange.50}',
      100: '{orange.100}',
      200: '{orange.200}',
      300: '{orange.300}',
      400: '{orange.400}',
      500: '{orange.500}',
      600: '{orange.600}',
      700: '{orange.700}',
      800: '{orange.800}',
      900: '{orange.900}',
      950: '{orange.950}'
    }
  }
})

const app = createApp(App)

// enable Sentry only in staging and production
if (import.meta.env.PROD && !import.meta.env.VITE_SENTRY_DISABLED) {
  Sentry.init({
    app,
    dsn: 'https://b7f3010eac30976d3b122a3c2f69e40f@o4510895486271488.ingest.de.sentry.io/4510896530653264',
    release: `vue-fuelexciseduties@${version}`,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

app.use(createPinia())
app.use(router)
app.use(PrimeVue, {
  ripple: true,
  locale: LOCALE_IT,
  theme: {
    preset: MyDefaultPreset,
    options: {
      darkModeSelector: '.app-dark',
      cssLayer: {
        name: 'primevue',
        order: 'theme, base, primevue, utilities'
      }
    }
  }
})
app.use(ToastService)
app.use(ConfirmationService)
app.component('DownloadExcel', JsonExcel)

app.mount('#app')
